module.exports = __webpack_public_path__ + "assets/media/morning.9941970e.mp3";